import template from "./pStyleguide.html";

export function pStyleguideDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pStyleguideController,
    controllerAs: 'pStyleguide',
    bindToController: true
  };

  return directive;
}

class pStyleguideController {
  constructor() {
    'ngInject';
    this.loremIpsum = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam condimentum cursus congue. Sed facilisis ante nec sem tempor posuere. Maecenas risus nisl, vulputate vitae iaculis sit amet, semper quis erat. Quisque nec est justo.';
  }
}